import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
      
      // Update active section based on scroll position
      const sections = ['home', 'techstack', 'experience', 'projects', 'testimonials'];
      const scrollPosition = window.scrollY + 100;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    // Prevent body scroll when mobile menu is open
    document.body.style.overflow = !mobileMenuOpen ? 'hidden' : 'auto';
  };

  const handleMobileNavClick = () => {
    setMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const navLinks = [
    { to: '/', label: 'HOME', id: 'experience' },
    // { to: '/experience', label: 'EXPERIENCE', id: 'experience' },
    { to: '/projects', label: 'PROJECTS', id: 'projects' },
    { to: '/contact', label: 'CONTACT', id: 'testimonials' },
    { to: '/techstack', label: 'TECH STACK', id: 'major-project' }
  ];

  return (
    
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Left Side Navigation */}
        <div className="nav-section left">
          {navLinks.slice(0, 2).map((link) => (
            <Link 
              key={link.id}
              to={link.to} 
              className={`nav-link ${activeSection === link.id ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Center Name */}
        <div className="nav-center">
          <Link to="/" className="name-logo" onClick={() => setActiveSection('home')}>
            <span className="first-name">RISHI SHINDE</span>
          </Link>
          <div className="title">
            FRONT END DEVELOPER | FULL STACK DEVELOPER | BACKEND DEVELOPER 
          </div>
        </div>

        {/* Right Side Navigation */}
        <div className="nav-section right">
          {navLinks.slice(2).map((link) => (
            <Link 
              key={link.id}
              to={link.to} 
              className={`nav-link ${activeSection === link.id ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
          onClick={handleMobileMenuToggle}
          aria-label="Toggle navigation"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          {/* <div className="mobile-menu-header">
            <h3>Navigation</h3>
            <button 
              className="mobile-menu-close"
              onClick={handleMobileMenuToggle}
              aria-label="Close menu"
            >
              ×
            </button>
          </div> */}
          
          <div className="mobile-nav-links">
            {navLinks.map((link) => (
              <Link 
                key={link.id}
                to={link.to} 
                className={`mobile-nav-link ${activeSection === link.id ? 'active' : ''}`}
                onClick={handleMobileNavClick}
              >
                {link.label}
              </Link>
            ))}
          </div>
          
          <div className="mobile-menu-footer">
            <p>Let's build something amazing together!</p>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;